import script from "./tab-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-panel.vue?vue&type=script&setup=true&lang=ts"

import "./tab-panel.vue?vue&type=style&index=0&id=a13f414c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a13f414c"]])

export default __exports__